import { RuleSet, Rule } from 'ngx-angular-query-builder';
import * as lodash from 'lodash';
import { Field } from 'ngx-angular-query-builder';
import { ITableColumn } from '@common/models/table';
import { FieldMetadataCollection } from '@common/filter/field-metadata';

export function getDefaultFilter() {
  return { condition: 'and', rules: [] } as RuleSet;
}

export function isNotDefaultFilter(checkFilter: RuleSet): boolean {
  return checkFilter.rules.length !== 0;
}

export function sortFunc(a: Field, b: Field, order: Array<string>) {

  const aIndex = order.indexOf(a.name);
  const bIndex = order.indexOf(b.name);

  //Sort by index in non-system columns if columns are selected

  if (aIndex > -1 && bIndex > -1) {
    return aIndex -
      bIndex;
  }
  //If one of the columns is selected, float to top of list
  if (aIndex > -1) {
    return -1;
  }
  if (bIndex > -1) {
    return 1;
  }

  //If neither column is selected, order alphabetically
  if (a.name.toLowerCase() > b.name.toLowerCase()) {
    return 1;
  } else if (b.name.toLowerCase() > a.name.toLowerCase()) {
    return -1;
  } else {
    return 0;
  }
}

export const andFilters = (...filters: (RuleSet | Rule)[]) => {
  const combinedFilter = getDefaultFilter();
  combinedFilter.condition = 'and';
  filters.map(filter => {
    if (filter) {
      combinedFilter.rules.push(lodash.cloneDeep(filter));
    }
  });
  return combinedFilter;
}

export function getFilterFieldsFromColumns(fmd: FieldMetadataCollection, columns: ITableColumn[]): Array<Field> {
  const nonSystemColumns = columns.filter(x => !x.Name.startsWith('System'));
  const nonSystemColumnHeaders = nonSystemColumns.map(x => x.Header);
  const fields = fmd.getFilterFields().map(x => {
    if (nonSystemColumnHeaders.indexOf(x.name) > -1) {
      x['styleClass'] = 'selected-column';
    }
    return x;
  });
  return fields.sort((a, b) => sortFunc(a, b, nonSystemColumnHeaders));
}

export function convertFieldValue(ruleValue: any, actualValue: any, fieldName: string, field: Field): any {

  const dateOnly = (d: string | Date) => {
    const i = new Date(d);
    i.setHours(0, 0, 0, 0);
    return i;
  }

  switch (field.type) {
    case 'category':
      {
        // Hack for MP-828
        // matches 'N' or empty string as "No"
        if (field.nullable && ruleValue == 'No') {
          if (actualValue == '') {
            actualValue = 'N';
          }
          return { checkValue: 'N', actualValue: actualValue };
        }
        // matches 'Y' as "Yes"
        if (field.nullable && ruleValue == 'Yes') {
          return { checkValue: 'Y', actualValue: actualValue };
        }
        // End Hack for MP-828

        // category type columns when marked as nullable can use "-1" to signify nulls
        if (field.nullable && ruleValue == '-1') {
          return { checkValue: null, actualValue: actualValue };
        }
        return { checkValue: ruleValue, actualValue: actualValue };
      }
    case 'string':
      {
        return Array.isArray(ruleValue)
          ? ruleValue.every(x => typeof x === "object" && 'value' in x)
            ? { checkValue: ruleValue.map(x => `${x.value}`.toLowerCase()), actualValue: `${actualValue}`.toLowerCase() }
            : { checkValue: ruleValue.map(x => `${x}`.toLowerCase()), actualValue: `${actualValue}`.toLowerCase() }
          : { checkValue: `${ruleValue}`.toLowerCase(), actualValue: `${actualValue}`.toLowerCase() };
      }
    case 'number':
      {
        return { checkValue: ruleValue, actualValue: actualValue };
      }
    case 'date':
      {
        // between
        if ((typeof ruleValue === "object" &&
          !Array.isArray(ruleValue) &&
          ruleValue !== null &&
          ruleValue['field1'] != undefined)) {

          const date1 = new Date(ruleValue.field1);
          date1.setHours(0, 0, 0);

          const date2 = new Date(ruleValue.field2);
          date2.setHours(23, 59, 59);

          return { checkValue: { field1: date1, field2: date2 }, actualValue: dateOnly(actualValue).getTime() };
        }

        // array of dates
        if (Array.isArray(ruleValue)) {
          // do we need to process the dates first
          return {
            checkValue: ruleValue.map(i => dateOnly(i).getTime()),
            actualValue: dateOnly(actualValue).getTime()
          };
        }

        // single date value
        const checkValue = dateOnly(ruleValue);
        const actual = dateOnly(actualValue);
        return { checkValue: checkValue.getTime(), actualValue: actual.getTime() }
      }
    default:
      {
        return { checkValue: ruleValue, actualValue: actualValue };
      }
  }
}
